import { useContext } from 'react'

import { WebPubSubClientManager } from '../client'
import { WebPubSubContext } from '../context'

export const useWebPubSub = (): WebPubSubClientManager => {
  const context = useContext(WebPubSubContext)

  if (!context) {
    throw new Error('useWebPubSub must be used within WebPubSubProvider')
  }

  return context
}
